export default __webpack_public_path__ + "static/media/ico-close.d0ceb831.svg";